import BannerMessageCode from "!!raw-loader!./messages/BannerMessage.tsx";
import ErrorMessagesCode from "!!raw-loader!./messages/ErrorMessages.tsx";
import InfoMessagesCode from "!!raw-loader!./messages/InfoMessages.tsx";
import WarningMessagesCode from "!!raw-loader!./messages/WarningMessages.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import BannerMessage from "./messages/BannerMessage";
import ErrorMessages from "./messages/ErrorMessages";
import InfoMessages from "./messages/InfoMessages";
import WarningMessages from "./messages/WarningMessages";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Banner Message", BannerMessageCode, BannerMessage),
		paneComponent("Error Messages", ErrorMessagesCode, ErrorMessages),
		paneComponent("Information Message", InfoMessagesCode, InfoMessages),
		paneComponent("Warning Message", WarningMessagesCode, WarningMessages),
	];


	return (
		<Pane
			components={components}
			imports={"import {Message} from \"designSystem/index\";"}
			{...props}
		/>
	);
};